import { UploadFile } from '@components/common/upload';
import { ProfileResumeAdditionInfoSaveDto } from '@domain/rq/match/MatchingApplicationApplyRq';
import ResumeAdditionInfoVO, { AdditionInfoVO, AnswerVO } from '@domain/vo/match/ResumeAdditionInfoVO';

export type FormDataType = Record<number, string | string[] | { label: string; value: string } | UploadFile[]>;

export const parsingFormData = ({
  formData,
  additionInfo,
}: {
  formData: FormDataType;
  additionInfo: AdditionInfoVO[];
}) => {
  const forms = Object.entries(formData).map(([key, value]) => {
    const infoSn = Number(key);
    const info = additionInfo.find((info) => info.additionInfoSn === infoSn);

    if (!info) return;

    switch (info.formType) {
      case 'TEXT':
        return {
          positionAdditionInfoSn: info.additionInfoSn,
          question: info.question,
          answer: value,
          type: info.formType,
        };
      case 'SINGLE_CHOICE':
        return {
          positionAdditionInfoSn: info.additionInfoSn,
          question: info.question,
          choices: info.choices.map((choice) => ({
            name: choice,
            selectYn: (value as string[])?.includes(choice),
          })),
          type: info.formType,
        };
      case 'MULTI_CHOICE':
        return {
          positionAdditionInfoSn: info.additionInfoSn,
          question: info.question,
          choices: info.choices.map((choice) => ({
            name: choice,
            selectYn: (value as string[])?.includes(choice),
          })),
          type: info.formType,
        };
      case 'DROPDOWN':
        return {
          positionAdditionInfoSn: info.additionInfoSn,
          question: info.question,
          choices: info.choices.map((choice) => ({
            name: choice,
            selectYn: (value as { label: string; value: string })?.value === choice,
          })),
          type: info.formType,
        };
      case 'ADDITION_ATTACH_FILE':
        return {
          positionAdditionInfoSn: info.additionInfoSn,
          question: info.question,
          files: (value as UploadFile[])?.map((file) => {
            return { uid: file.fileUid, name: file.fileName };
          }),
          type: info.formType,
        };
    }
  }) as ProfileResumeAdditionInfoSaveDto[];

  return forms;
};

export const convertFormInitValue = (additionInfo: AnswerVO[]) => {
  const convertInitValue = {} as any;
  additionInfo.forEach((item) => {
    if (item.type === 'TEXT' && item.answer) {
      convertInitValue[item.additionInfoSn] = item.answer;
      return;
    } else if (item.type === 'SINGLE_CHOICE' && item.choices) {
      const selectValue = item.choices.filter((choice) => choice.selectYn).map((choice) => choice.name);
      convertInitValue[item.additionInfoSn] = selectValue;
      return;
    } else if (item.type === 'MULTI_CHOICE' && item.choices) {
      const selectValue = item.choices.filter((choice) => choice.selectYn).map((choice) => choice.name);
      convertInitValue[item.additionInfoSn] = selectValue;
      return;
    } else if (item.type === 'DROPDOWN' && item.choices) {
      const selectValue = item.choices.find((choice) => choice.selectYn === true);
      convertInitValue[item.additionInfoSn] = { label: selectValue?.name, value: selectValue?.name };
      return;
    } else if (item.type === 'ADDITION_ATTACH_FILE' && item.files) {
      convertInitValue[item.additionInfoSn] = item.files.map((file) => {
        return {
          fileUid: file.uid,
          fileName: file.name,
        };
      });
    }
  });

  return convertInitValue;
};

export const isAdditionValid = (additionItems: ResumeAdditionInfoVO) => {
  const saveAnswers = additionItems?.additionInfo.map((item) => item.answer);

  return saveAnswers?.every((item) => item?.isValid);
};
